/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Why questions of a part stay out of its pool; each question counts once, under the first reason that applies, in this order. SURVEY_QUESTION — meant for surveys. NOT_IN_USE — no version in force. MARKED_BY_EXAMINER — of a type an examiner marks, which only a practical exam takes. NOT_ONE_POINT — worth other than one point, which only a practical exam takes. SCORED_BY_SYSTEM — of a type the system scores, which a practical exam leaves to the theory exam beside it. CHOSEN_IN_ANOTHER_PART — chosen by hand in a part of chosen questions, which comes first: a question is in a test once. NO_APPROVED_WORDING — no approved wording in the language named, so the test cannot show it in that language.
 * @export
 * @enum {string}
 */

export const PoolSkipReasonDto = {
    SurveyQuestion: 'SURVEY_QUESTION',
    NotInUse: 'NOT_IN_USE',
    MarkedByExaminer: 'MARKED_BY_EXAMINER',
    ScoredBySystem: 'SCORED_BY_SYSTEM',
    NotOnePoint: 'NOT_ONE_POINT',
    ChosenInAnotherPart: 'CHOSEN_IN_ANOTHER_PART',
    NoApprovedWording: 'NO_APPROVED_WORDING'
} as const;

export type PoolSkipReasonDto = typeof PoolSkipReasonDto[keyof typeof PoolSkipReasonDto];



